import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the table balance adjustments view.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'ActionTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Acción'), // Tooltip for the action column
                                    template: function (obj) {
                                        // Template for displaying action icons based on state
                                        if (obj.State == '0') {
                                            return "<span class='webix_icon wxi-close torefuse'></span>";
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                { id: 'Id', header: _('Id'), width: 100 }, // ID column
                                {
                                    id: 'UserName',
                                    header: _('Usuario'), // User name column
                                    width: 250,
                                },
                                {
                                    id: 'AccountBank',
                                    header: _('Número de cuenta'), // Bank account number column
                                    width: 150,
                                },
                                {
                                    id: 'CreationDate',
                                    header: _('Fecha de creación'), // Creation date column
                                    width: 150,
                                },
                                {
                                    id: 'AmountBase',
                                    header: _('Valor'), // Base amount column
                                    format: webix.i18n.priceFormat, // Format for displaying price
                                    exportType: 'number', // Export type for the column
                                    width: 150,
                                },
                                {
                                    id: 'Tax',
                                    header: _('Impuesto'), // Tax column
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 150,
                                },
                                {
                                    id: 'NetAmount',
                                    header: _('Valor Final'), // Final amount column
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                    width: 150,
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // State column
                                    width: 150,
                                    options: [
                                        { id: '0', value: _('Activa') },
                                        { id: '1', value: _('Eliminado') },
                                        { id: '2', value: _('Pendiente') },
                                        { id: '3', value: _('Pagado') },
                                        { id: '4', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'PayDate',
                                    header: _('Fecha de pago'), // Payment date column
                                    width: 150,
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show overlay before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Hide overlay after loading data
                                    this.hideOverlay();
                                },
                            },
                            ready: function () {
                                // Show no data overlay if there are no records
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            onClick: {
                                torefuse: function (euv, id) {
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea cancelar nota de retiro?'), // Confirmation message
                                        ok: _('Cancelar Nota'), // OK button label
                                        cancel: _('Salir'), // Cancel button label
                                        callback: function (action) {
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item to cancel
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'BankComissions/CancelWithdrawls',
                                                        '{ "Id":' + item.Id + '}', // Payload for the request
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var resp = JSON.parse(text);
                                                                if (!resp.HasError) {
                                                                    item.State = '1'; // Update item state to 'deleted'
                                                                    webix.message(_('Nota de retiro cancelada'));
                                                                    vthis.$$('datatable').refresh(); // Refresh the datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'BankComissions/GetWithdrawls'; // API URL for fetching withdrawals
        var optionsBanks = []; // Array to hold bank options
        var popupAdd; // Variable to hold the popup window
        var filter = ''; // Filter string for data fetching

        // Event listener for filtering data
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });

        /**
         * Converts a file to a Base64 string.
         * @param {File} file - The file to convert.
         * @returns {Promise<string>} A promise that resolves with the Base64 string.
         */
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file); // Read file as data URL
                reader.onload = () => resolve(reader.result); // Resolve with result
                reader.onerror = (error) => reject(error); // Reject on error
            });
        }

        var base64CSV2 = ''; // Variable to hold Base64 encoded CSV

        // Event listener for adding a new withdrawal
        this.on(this.app, 'add:button', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .get(devConfig.geturlApi() + 'Financial/GetBankAccountsComissions?start=0&count=1000&State=0', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        optionsBanks = resp.data; // Store bank options
                        optionsBanks.forEach((item) => {
                            item.id = item.Id; // Set ID for each bank option
                            item.value = item.Bank + '-' + item.Account; // Set display value
                        });
                        popupAdd = webix.ui({
                            view: 'window',
                            height: 550,
                            head: {
                                view: 'toolbar',
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Retirar'), // Window title
                                        align: 'center',
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close',
                                        click: function () {
                                            this.getTopParentView().hide(); // Close the popup
                                        },
                                    },
                                ],
                            },
                            position: 'center', // Center the popup
                            modal: true, // Make the popup modal
                            body: {
                                view: 'form',
                                id: 'addform', // ID for the form
                                elements: [
                                    {
                                        id: 'r5',
                                        rows: [
                                            {
                                                view: 'text',
                                                label: _('Valor') + ':', // Value input
                                                name: 'Value',
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                type: 'number',
                                                required: true, // Required field
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Cuenta') + ':', // Bank account selection
                                                name: 'AccountBank',
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                required: true,
                                                options: optionsBanks, // Options for bank accounts
                                            },
                                            {
                                                view: 'combo',
                                                label: _('Saldo a retirar') + ':', // Withdrawal type selection
                                                name: 'WithdrawType',
                                                id: 'WithdrawTypeSelect',
                                                labelWidth: 150,
                                                labelPosition: 'top',
                                                required: true,
                                                options: [
                                                    {
                                                        id: '0',
                                                        value: _('Cupo de venta'),
                                                    },
                                                    {
                                                        id: '1',
                                                        value: _('Comisiones'),
                                                    },
                                                ],
                                                on: {
                                                    onChange: function (data, obj) {
                                                        var currentValue = this.getValue(); // Get current value of withdrawal type
                                                        if (currentValue == '1') {
                                                            $$('r5').addView({
                                                                id: 'r6',
                                                                rows: [
                                                                    {
                                                                        view: 'uploader',
                                                                        id: 'uploader3', // ID for the uploader
                                                                        value: _(
                                                                            'Cargar factura PDF', // Uploader label
                                                                        ),
                                                                        on: {
                                                                            onBeforeFileAdd: function (upload) {
                                                                                getBase64(upload.file).then(
                                                                                    (data) => (base64CSV2 = data), // Store Base64 data
                                                                                );
                                                                                $$('uploader3').define(
                                                                                    'label',
                                                                                    upload.name, // Set uploader label to file name
                                                                                );
                                                                                $$('uploader3').refresh(); // Refresh uploader
                                                                            },
                                                                        },
                                                                    },
                                                                ],
                                                            });
                                                            $$('r5').removeView(
                                                                'r7', // Remove refund question if not needed
                                                            );
                                                        } else {
                                                            $$('r5').addView({
                                                                id: 'r7',
                                                                rows: [
                                                                    {
                                                                        view: 'combo',
                                                                        label: _('Es para reembolso?') + ':', // Refund question
                                                                        name: 'IsForRefund',
                                                                        labelWidth: 150,
                                                                        labelPosition: 'top',
                                                                        required: true,
                                                                        value: 'N', // Default value
                                                                        options: [
                                                                            {
                                                                                id: 'S',
                                                                                value: _('Sí'),
                                                                            },
                                                                            {
                                                                                id: 'N',
                                                                                value: _('No'),
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            });
                                                            $$('r5').removeView(
                                                                'r6', // Remove file uploader if not needed
                                                            );
                                                        }
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Cancel button
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close the popup
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: _('Guardar'), // Save button
                                                click: function ($e) {
                                                    var values = $$('addform').getValues(); // Get form values
                                                    const params = {
                                                        Value: parseFloat(
                                                            values.Value, // Parse value to float
                                                        ),
                                                        AccountBank: values.AccountBank,
                                                        WithdrawType: values.WithdrawType,
                                                        IsForRefund: values.IsForRefund,
                                                    };
                                                    if ($$('WithdrawTypeSelect').getValue() == '1') {
                                                        if (base64CSV2 != '') {
                                                            params.Invoice = base64CSV2; // Add invoice if present
                                                        } else {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Cargar factura PDF', // Error message for missing invoice
                                                                ),
                                                            });
                                                            return false;
                                                        }
                                                    }
                                                    if ($$('addform').validate()) {
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'BankComissions/CreateWithdraw',
                                                                params, // Send parameters to create withdrawal
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var json = JSON.parse(
                                                                            text, // Parse response
                                                                        );
                                                                        if (json.HasError) {
                                                                            webix.message({
                                                                                title: _('¡Error!'),
                                                                                type: 'alert-error',
                                                                                text: json.AlertMessage, // Show error message from response
                                                                            });
                                                                        } else {
                                                                            webix.message(
                                                                                'Retiro creado satisfactoriamente', // Success message
                                                                            );
                                                                            grid.clearAll(); // Clear grid data
                                                                            grid.load(
                                                                                url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter, // Reload grid data
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Reset form values
                                                        );
                                                        this.getTopParentView().hide(); // Close the popup
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _(
                                                                'Completa los campos...', // Error message for validation failure
                                                            ),
                                                        });
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                                elementsConfig: {
                                    on: {
                                        onChange: function () {
                                            this.validate(); // Validate form on change
                                        },
                                    },
                                },
                            },
                        });
                        popupAdd.show(); // Show the popup
                        $$('addform').clearValidation(); // Clear validation messages
                    },
                });
        });
    }
}

// FILE DOCUMENTED
